export default __webpack_public_path__ + "static/media/teisslP.b17457e6.jpg";